// extracted by mini-css-extract-plugin
export var contentBody = "_dx-9";
export var headerImage = "_dx-2";
export var imageButton = "_dx-7";
export var imageButtonIcon = "_dx-8";
export var imageHeader = "_dx-4";
export var imageHeaderText = "_dx-5";
export var imageOverlay = "_dx-3";
export var imageTitle = "_dx-6";
export var imageWrapper = "_dx-1";
export var taskList = "_dx-a";
export var widget = "_dx-0";